function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import shared from "./shared";
import { blue30, white } from '../../../../eden-style-constants';
import styled from "styled-components";
const Component = styled.button.withConfig({
  componentId: "sc-1lb7nf5-0"
})(["", ";", " ", ";color:", ";&:hover{background:", ";color:", ";}&:active{", " ", ";}"], shared, ({
  inverted
}) => inverted ? `background: linear-gradient(
        138.17deg, 
        rgba(255, 255, 255, 0) 12.7%, 
        rgba(0, 97, 132, 0.2) 106.8%
  ),` : `background: linear-gradient(
        153.43deg, 
        rgba(255, 255, 255, 0.4) 0%, 
        rgba(255, 255, 255, 0) 83.33%
  ),`, ({
  theme,
  inverted
}) => theme.primaryColor ? theme.primaryColor : inverted ? white : blue30, ({
  theme,
  inverted
}) => inverted && !theme.primaryColor ? blue30 : white, ({
  theme,
  inverted
}) => theme.primaryColor ? theme.primaryColor : inverted ? white : blue30, ({
  theme,
  inverted
}) => inverted && !theme.primaryColor ? blue30 : white, ({
  inverted
}) => inverted ? `background: linear-gradient(
          137.89deg, 
          rgba(0, 97, 132, 0.2) -6.82%, 
          rgba(255, 255, 255, 0) 87.48%
      ),` : `background: linear-gradient(
          154.04deg, 
          rgba(255, 255, 255, 0) 16.55%, 
          rgba(255, 255, 255, 0.4) 100%
      ),`, ({
  theme,
  inverted
}) => theme.primaryColor ? theme.primaryColor : inverted ? white : blue30);
/**
 * Primary buttons are used to indicate that an action is strongly recommended for a user to complete a specific task.
 */

const Primary = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));
Primary.defaultProps = {
  type: "button"
};
Primary.displayName = "Primary";
Primary.propTypes = {
  /** The button contents */
  children: PropTypes.node.isRequired,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: PropTypes.bool,

  /** Whether to apply smaller styles */
  small: PropTypes.bool,

  /** Theme style values */
  theme: PropTypes.shape({
    primaryColor: PropTypes.string
  }),

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: PropTypes.string,

  /** If the button should expand to the full width of its parent */
  fullWidth: PropTypes.bool,

  /** If the button should be disabled */
  disabled: PropTypes.bool,

  /** The link that the button should navigate to on click */
  href: PropTypes.string
};
export default Primary;